import React, { useEffect, useState } from 'react';
import { Card, Button, Table, Spinner, Modal } from 'react-bootstrap';
import { FaPlus, FaEdit, FaTrash } from 'react-icons/fa';
import CuentasContablesForm from './CuentasContablesForm';
import { getDataList, crearDatos, actualizarDatos, getDataObtenerUno, eliminarDatos } from '../../api/common';
import { Alertassw } from '../Alertas/Alertassw';

const COLLECTION = 'CuentasContables'; // Ajustar si el endpoint tiene otro nombre

const CuentasContables = () => {
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState({ show: false, item: null, deleting: false });

  useEffect(() => {
    fetchList();
  }, []);

  const fetchList = async () => {
    try {
      setLoading(true);
      const resp = await getDataList(COLLECTION, {});
      if (resp && resp.status === 200) setItems(resp.data.data || []);
      else setItems([]);
    } catch (err) {
      console.error(err);
      Alertassw('error', 'Error', 'No se pudo obtener el listado');
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = () => {
    setEditing(null);
    setShowForm(true);
  };

  const handleEdit = async (item) => {
    try {
      // intentamos obtener datos actualizados desde el backend
      const resp = await getDataObtenerUno(COLLECTION, { _id: item._id || item.id });
      if (resp && resp.status === 200) setEditing(resp.data.data || item);
      else setEditing(item);
      setShowForm(true);
    } catch (err) {
      console.error(err);
      setEditing(item);
      setShowForm(true);
    }
  };

  const handleSave = async (data) => {
    try {
      if (editing && (editing._id || editing.id)) {
        const id = editing._id || editing.id;
        const resp = await actualizarDatos(COLLECTION, data, id);
        if (resp && resp.status === 200) {
          Alertassw('success', 'Actualizado', 'Cuenta actualizada correctamente');
          fetchList();
          return resp.data;
        }
      } else {
        const resp = await crearDatos(COLLECTION, data);
        if (resp && resp.status === 200) {
          Alertassw('success', 'Creado', 'Cuenta creada correctamente');
          fetchList();
          return resp.data;
        }
      }
    } catch (err) {
      console.error(err);
      Alertassw('error', 'Error', err?.message || 'Error guardando cuenta');
      throw err;
    }
  };

  const handleDelete = (item) => {
    setConfirmDelete({ show: true, item, deleting: false });
  };

  const confirmDeleteAction = async () => {
    const item = confirmDelete.item;
    if (!item) return;
    setConfirmDelete(prev => ({ ...prev, deleting: true }));
    try {
      const id = item._id || item.id;
      const resp = await eliminarDatos(COLLECTION, id);
      if (resp && resp.status === 200) {
        Alertassw('success', 'Eliminado', 'Cuenta eliminada correctamente');
        fetchList();
      } else {
        Alertassw('error', 'Error', 'No se pudo eliminar la cuenta');
      }
    } catch (err) {
      console.error(err);
      Alertassw('error', 'Error', err?.message || 'Error eliminando');
    } finally {
      setConfirmDelete({ show: false, item: null, deleting: false });
    }
  };

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Cuentas Contables</h4>
        <div>
          <Button variant="success" onClick={handleCreate}><FaPlus /> Crear cuenta</Button>
        </div>
      </div>

      <Card className="shadow-sm w-100">
        <Card.Body className='w-100'>
          {loading ? (
            <div className="d-flex justify-content-center py-4">
              <Spinner animation="border" />
            </div>
          ) : (
            <div className="table-responsive">
              <Table hover>
                <thead className="table-light">
                  <tr>
                    <th>Código</th>
                    <th>Clase</th>
                    <th>Nombre</th>
                    <th>Responsable</th>
                    <th>Categoría</th>
                    <th>Nivel</th>
                    <th>Naturaleza</th>
                    <th>Activo</th>
                    <th className="text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((it, idx) => (
                    <tr key={it._id || it.id || idx}>
                      <td>{it.codigo}</td>
                      <td>{it.clase}</td>
                      <td>{it.nombre}</td>
                      <td>{it.responsable?.nombre || 'N/A'} {it.responsable?.apellido || ' '}</td>
                      <td>{it.categoria}</td>
                      <td>{it.nivel}</td>
                      <td>{it.naturaleza}</td>
                      <td>{it.activo ? 'Sí' : 'No'}</td>
                      <td className="text-center">
                        <div className="d-flex justify-content-center gap-2">
                          <Button size="sm" variant="outline-primary" onClick={() => handleEdit(it)}><FaEdit /> Edit</Button>
                          <Button size="sm" variant="outline-danger" onClick={() => handleDelete(it)}><FaTrash /> Del</Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </Card.Body>
      </Card>

      <CuentasContablesForm
        show={showForm}
        onHide={() => { setShowForm(false); setEditing(null); }}
        initialData={editing}
        onSuccess={async (data) => { await handleSave(data); }}
        collection={COLLECTION}
      />

      <Modal show={confirmDelete.show} onHide={() => setConfirmDelete({ show: false, item: null, deleting: false })} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar eliminación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>¿Deseas eliminar la cuenta <strong>{confirmDelete.item?.codigo}</strong> - {confirmDelete.item?.nombre} ?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setConfirmDelete({ show: false, item: null, deleting: false })} disabled={confirmDelete.deleting}>Cancelar</Button>
          <Button variant="danger" onClick={confirmDeleteAction} disabled={confirmDelete.deleting}>{confirmDelete.deleting ? 'Eliminando...' : 'Eliminar'}</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CuentasContables;
